import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import actions from './actions';
import newsModule from './modules/newsModule';
import hrNewsModule from './modules/hrNewsModule';
import disruptorsModule from './modules/disruptorsModule';
import financeModule from './modules/financeModule';
import companyListModule from './modules/companyListModule';
import benchmarkModule from './modules/benchmarkModule';
import econPredictorModule from './modules/econPredictorModule';
import companyIndexesModule from './modules/companyIndexesModule';
import institutionModule from './modules/institutionModule';
import orgChartModule from './modules/orgChartModule';
import jobModule from './modules/jobModule';
import unigradsModule from './modules/unigradsModule';
import minWageModule from './modules/minWageModule';
import hrPredictModule from './modules/hrPredictModule';
import relocationModule from './modules/relocationModule';
import newsTaggerModule from './modules/newsTaggerModule';
import zhaopinModule from './modules/zhaopinModule';
import legislationModule from './modules/legislationModule';
import livingCostModule from './modules/livingCostModule';
import freshGradSalModule from './modules/freshGradSalModule';
import executivePayModule from './modules/executivePayModule';
import adminModule from './modules/adminModule';
import genderModule from './modules/genderModule';

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  // strict: false,
  state: {
    currentUser: {
      company: '',
      userid: '',
      username: '',
      roles: [],
    },
    cent: { },
    userChatLogPulled: {},
    chatMode: 'list',
    chatUser: {},
    chatStatus: true,
    chatActive: false,
    currentUserCountry: {},
    msges: {},
    chatChoices: {},
    majorCurrencies: ['USD', 'EUR', 'GBP',
      'CNY', 'HKD', 'MOP', 'KRW', 'TWD', 'JPY',
      'SGD', 'MYR', 'IDR', 'THB', 'PHP', 'VND', 'MMK', 'KHR',
      'BDT', 'INR', 'PKR', 'LKR', 'AUD', 'NZD', 'CHF'],
    currencyExchangeRates: [],
    contacts: {},
    onlineContacts: [],
  },
  mutations,
  actions,
  modules: {
    news: newsModule,
    hrNews: hrNewsModule,
    disruptors: disruptorsModule,
    finance: financeModule,
    companyList: companyListModule,
    benchmark: benchmarkModule,
    econPredictor: econPredictorModule,
    companyIndexes: companyIndexesModule,
    institution: institutionModule,
    orgChart: orgChartModule,
    job: jobModule,
    unigrads: unigradsModule,
    minWage: minWageModule,
    hrPredict: hrPredictModule,
    relocation: relocationModule,
    newsTagger: newsTaggerModule,
    zhaopin: zhaopinModule,
    legislation: legislationModule,
    livingCost: livingCostModule,
    freshgradsal: freshGradSalModule,
    executivepay: executivePayModule,
    admin: adminModule,
    gender: genderModule,
  },
});
export default store;



// WEBPACK FOOTER //
// ./src/store/state.js